<template>
  <div class="animated fadeIn upload-prk">
    <b-card v-if="!showUploadFrm">
      <div slot="header">
        Hasil Import Data Jaminan
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="confirmSave=!confirmSave" :disabled="!saveEnabled">
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-primary mr-1" @click="cancel()">
            <i class="fa fa-close"></i> {{$t('cancel')}}
          </button>
        </div>
      </div>
      <b-card no-body>
        <template v-slot:header v-if="(filterShow=='Hide')">
          <b-row>
            <b-col lg="3">
              <b-input-group size="sm" class="mt-1">
                <b-input-group-prepend>
                  <span class="pt-1 mr-1">FILTER</span>
                </b-input-group-prepend>
                <b-form-input
                  v-model="filter"
                  type="search"
                  id="filterInput"
                  placeholder="Type to Search"
                ></b-form-input>
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="clearFilter">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
              <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch>
                <b>{{ filterShow }}</b> Filter
              </b-form-checkbox>
            </b-col>
            <b-col lg="9">
              <b-form-group
                label="FILTER ON :"
                label-cols-sm="1"
                description="Leave all unchecked to filter on all data"
                class="mb-0"
              >
                <b-form-checkbox-group v-model="filterOn" class="mt-1">
                  <b-form-checkbox
                    v-for="(item,index) in tblLcy.fields.filter(dt => dt.filterable==true) "
                    :key="index"
                    :value="item.key"
                  >{{item.label}}</b-form-checkbox>
                </b-form-checkbox-group>
              </b-form-group>
            </b-col>
          </b-row>
        </template>
        <b-table
          class="mb-0 text-nowrap"
          ref="tableOri"
          sticky-header="600px"
          outlined
          responsive
          striped
          hover
          style="font-size:smaller;"
          :items="rptLines"
          :fields="tblLcy.fields"
          :current-page="tblLcy.page"
          :per-page="tblLcy.limit"
          :sort-by.sync="tblLcy.sortBy"
          :sort-desc.sync="tblLcy.sortDesc"
          :filter="filter"
          :filterIncludedFields="filterOn"
          @filtered="onFiltered"
        >
          <template
            v-slot:cell(nilaijaminan)="data"
          >{{ data.item.nilaijaminan | numFormat('0,0.00') }}</template>
          <template v-slot:custom-foot="data">
            <b-tr>
              <b-td colspan="5" class="text-right">
                <h6>Total Nilai Jaminan</h6>
              </b-td>
              <b-td class="text-right">
                <h6>{{subtotal.nilaijaminan | numFormat('0,0.00')}}</h6>
              </b-td>
            </b-tr>
          </template>
        </b-table>
        <b-row class="mt-2">
          <b-col lg="4">
            <div class="ml-2">
              Showing {{(tblLcy.page - 1) * tblLcy.limit + 1}}
              to
              <span
                v-if="((tblLcy.page * tblLcy.limit)>tblLcy.total)"
              >{{tblLcy.total}}</span>
              <span v-else>{{tblLcy.page * tblLcy.limit}}</span>
              of {{tblLcy.total}} entries.
            </div>
          </b-col>
          <b-col cols="4">
            <b-row class="justify-content-center">
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <span class="mr-1">limit per page :</span>
                    <select v-model="tblLcy.limit" style="width:60px;">
                      <option>10</option>
                      <option>15</option>
                      <option>20</option>
                      <option>25</option>
                      <option>30</option>
                      <option>40</option>
                      <option>50</option>
                      <option>60</option>
                      <option>70</option>
                      <option>80</option>
                      <option>90</option>
                    </select>
                  </div>
                </div>
              </b-col>
              <b-col cols="12">
                <div style="display: flex;margin:0;padding:0;">
                  <div style="margin:0;padding:5px;width:500px; text-align:center;">
                    <b-form-checkbox
                      v-model="filterShow"
                      value="Hide"
                      unchecked-value="Show"
                      switch
                    >
                      <b>{{ filterShow }}</b> Filter
                    </b-form-checkbox>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="4">
            <b-pagination
              class="ml-1"
              align="right"
              :total-rows="tblLcy.total"
              :per-page="tblLcy.limit"
              v-model="tblLcy.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </b-card>
    </b-card>
    <b-row align-h="center" v-else>
      <b-col md="10">
        <b-card>
          <div slot="header">
            Import Data Jaminan
            <div class="card-header-actions">
              <div>
                <b-button class="btn-normal alert mb-2 mr-2" @click="close">
                  <i class="fa fa-times"></i> Close
                </b-button>
              </div>
            </div>
          </div>

          <b-card class="ColsDefine">
            <strong>Difinisi nama Kolom Excel untuk setiap Fileld pada data Jaminan</strong>
            <b-row>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. Kontrak</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.no_kontrak"
                    :plain="true"
                    :options="kolomXls"
                    :state="!$v.frmUpload.no_kontrak.$error"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nama Jaminan</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.namajaminan"
                    :plain="true"
                    :options="kolomXls"
                    :state="!$v.frmUpload.namajaminan.$error"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Pemilik Jaminan</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.pemilikjaminan"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>
                      Hubungan Dengan
                      <br />Pemilik
                    </label>
                  </b-input-group-prepend>
                  <b-form-select
                    style="height: 2.5em"
                    v-model="frmUpload.hubungandgnpemilik"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Tipe Jaminan</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.tipejaminan"
                    :plain="true"
                    :options="kolomXls"
                    :state="!$v.frmUpload.tipejaminan.$error"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Nilai Jaminan</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.nilaijaminan"
                    :plain="true"
                    :options="kolomXls"
                    :state="!$v.frmUpload.nilaijaminan.$error"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Sertifikat No.</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.sertifikatno" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Sertifikat Status</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.sertifikatstatus"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Luas Tanah</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.luastanah" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Luas Bangunan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.luasbangunan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No. IMB</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.noimb" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>BPKB</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.bpkb" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>STNK</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.stnk" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>No Polis Asuransi</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.statusasuransi"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Jt. Tempo Asuransi</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.jttmpasuransi"
                    :plain="true"
                    :options="kolomXls"
                  ></b-form-select>
                </b-input-group>
              </b-col>
              <b-col lg="3">
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Alamat Jaminan</label>
                  </b-input-group-prepend>
                  <b-form-select
                    v-model="frmUpload.alamat"
                    :plain="true"
                    :options="kolomXls"
                    :state="!$v.frmUpload.alamat.$error"
                  ></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kelurahan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kelurahan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kecamatan</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kecamatan" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kota</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kota" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Provinsi</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.provinsi" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
                <b-input-group>
                  <b-input-group-prepend>
                    <label>Kodepos</label>
                  </b-input-group-prepend>
                  <b-form-select v-model="frmUpload.kodepos" :plain="true" :options="kolomXls"></b-form-select>
                </b-input-group>
              </b-col>
            </b-row>
          </b-card>
          <b-input-group>
            <b-input-group-prepend>
              <label>Choose *.XLSX file</label>
            </b-input-group-prepend>
            <b-form-file
              v-model="fileXlsx"
              :state="!$v.fileXlsx.$error"
              placeholder="Choose a XLSX file..."
              drop-placeholder="Drop XLSX file here..."
            ></b-form-file>
          </b-input-group>
          <b-row no-gutters>
            <b-col lg="6">
              <b-input-group>
                <b-input-group-prepend>
                  <label>Nama SHEET</label>
                </b-input-group-prepend>
                <b-form-input v-model="frmUpload.sheetName" :state="!$v.frmUpload.sheetName.$error"></b-form-input>
              </b-input-group>
            </b-col>
            <b-col lg="5">
              <b-input-group>
                <b-input-group-append>
                  <label class="input-group-text ml-1">Data mulai baris ke-</label>
                </b-input-group-append>
                <b-form-input
                  v-model="frmUpload.startRow"
                  type="number"
                  :state="!$v.frmUpload.startRow.$error"
                ></b-form-input>
              </b-input-group>
            </b-col>
          </b-row>
          <div slot="footer" class="text-center">
            <b-button variant="primary" @click="importdata()">Import</b-button>
            <b-button variant="danger" @click="close()">Cancel</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal
      id="modal-prevent-closing"
      ref="modal"
      title="Konfirmasi"
      v-model="confirmSave"
      @ok="saveimportdata"
    >
      <div class="my-2 text-center">
        <p>Anda akan memproses data ini.</p>
        <p>Apakah anda yakin?</p>
      </div>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal v-model="showReport" size="lg" title="Preview as PDF" ok-only>
      <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>
  </div>
</template>

<style lang="scss" scoped>
.upload-prk {
  iframe {
    border: 1px solid #ccc;
    width: 100%;
    height: 11in;
  }
  .ColsDefine {
    .input-group {
      .input-group-prepend {
        label {
          width: 135px !important;
        }
      }
    }
  }
}
</style>

<script>
import crud from "../../apis/crud";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import klmXls from "../../data/kolomXls.json";
import agunan from "../../apis/agunankredit";
toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmUpload: {
      sheetName: { required },
      startRow: { required },
      no_kontrak: { required },
      namajaminan: { required },
      tipejaminan: { required },
      nilaijaminan: { required },
      alamat: { required },
    },
    fileXlsx: {
      required,
    },
  },
  data() {
    return {
      showUploadFrm: true,
      confirmSave:false,
      saveEnabled:true,
      fileXlsx: null,
      frmUpload: {
        sheetName: "DAFTAR_JAMINAN",
        startRow: 4,
        no_kontrak: "A",
        namajaminan: "DC",
        tipejaminan: "DD",
        nilaijaminan: "ES",
        alamat: "EN",
      },
      kolomXls: klmXls,
      isLoading: false,
      showReport: false,
      reportUrl: `${location.origin}/#load`,
      model: { account: "", tgl1: "", tgl2: "" },
      uanguser: this.$store.state.user.matauang,
      accounts: [],
      rptLines: [],
      subtotal: {},
      filterShow: "Show",
      tblLcy: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: null,
        sortDesc: false,
        fields: [
          {
            key: "no_kontrak",
            label: "No.Kontrak",
            sortable: true,
            filterable: true,
          },
          {
            key: "namajaminan",
            label: "Nama Jaminan",
            sortable: true,
            filterable: true,
          },
          {
            key: "pemilikjaminan",
            label: "Pemilik Jaminan",
            sortable: true,
            filterable: true,
          },
          {
            key: "tipejaminan",
            label: "Tipe Jaminan",
            thStyle: "width:100px",
            sortable: true,
            filterable: true,
          },
          {
            key: "alamat",
            label: "Alamat Jaminan",
            sortable: true,
            filterable: true,
          },
          {
            key: "nilaijaminan",
            label: "Nilai Jaminan",
            thStyle: "width:140px",
            tdClass: "text-right",
            sortable: true,
            filterable: true,
          },
        ],
      },
      filter: null,
      filterOn: [],
    };
  },
  components: { Loading },
  computed: {
    invalidFrmUpload() {
      this.$v.frmUpload.$touch();
      return this.$v.frmUpload.$invalid;
    },
    invalidFileXlsx() {
      this.$v.fileXlsx.$touch();
      return this.$v.fileXlsx.$invalid;
    },
  },
  watch: {
    rptLines(value) {
      this.calcsum(value);
    },
  },
  created: async function () {
    const collSet = { tablename: "uploaddatajaminan" };
    const uploadDt = await crud.list(collSet);
    if (uploadDt.length > 0) {
      const objDt = uploadDt[0];
      for (const key in objDt) {
        if ((objDt[key] || "") != "") {
          this.frmUpload[key] = objDt[key];
        }
      }
    }
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.tblLcy.total = filteredItems.length;
      this.tblLcy.page = 1;
      this.subtotal.nilaijaminan = filteredItems.reduce((total = 0, item) => {
        total += item.nilaijaminan;
        return total;
      }, 0);
    },
    clearFilter() {
      this.filterOn = [];
      this.filter = "";
    },
    calcsum(result) {
      this.subtotal.nilaijaminan = result.reduce((total = 0, item) => {
        total += item.nilaijaminan;
        return total;
      }, 0);
    },
    async importdata() {
      if (this.invalidFrmUpload || this.invalidFileXlsx) {
        toastr.error("Please fill the form correctly.");
      } else {
        try {
          this.isLoading = true;
          const result = await agunan.importdtxls(
            this.fileXlsx,
            this.frmUpload
          );
          this.rptLines = result;
          this.tblLcy.total = result.length;

          this.isLoading = false;
          this.showUploadFrm = false;
        } catch (error) {
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    async saveimportdata() {
      if (this.rptLines.length == 0) {
        toastr.warn("Data is empty");
      } else {
        try {
          this.isLoading = true;
          this.saveEnabled=false;
          const { keys } = await agunan.savebulk(this.rptLines);
          toastr.success("Data berhasil diimport");
          router.push({ name: "loan.agunanlist", params: { keys } });
          this.isLoading = false;
          this.saveEnabled=true;
          // this.showUploadFrm = true;
        } catch (error) {
          this.saveEnabled=true;
          this.isLoading = false;
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    close() {
      router.push("home");
    },
    cancel() {
      this.showUploadFrm = true;
      this.rptLines = [];
    },
  },
};
</script>
